import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { deepClone } from '../../../../helpers/utils';
import { getCobraTransmissions} from '../../../../core/store/benefitPlanEDI/benefitPlanEDI.action';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { CobraTransmissionModel } from '../../../../models/benefitPlanEDIMemberInformationModel';
import { ModifiedSelectItem, UserAutoCompleteItem } from '../../../../models/utilModels';
import { DateRangeModel } from '../../../../models/dateRangeModel';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { loadEmployeeUsers } from '../../../../core/store/employee/employee.action';

@Component({
    selector: 'app-transmission-cobra',
    templateUrl: './transmission-cobra.component.html',
    styleUrls: ['./transmission-cobra.component.scss'],
    standalone: false
})
 
export class TransmissionCobraComponent extends BaseComponent implements OnInit {
  filter: any = {};
  list: PagingResultsModel<CobraTransmissionModel>;

  loadingList: boolean = true;
  exportingExcel: boolean = false;

  selectedItem: CobraTransmissionModel = null;

  fileName: string = null;

  fileTypes: ModifiedSelectItem[] = [
    { label: 'All', value: 'ALL' },
    { label: 'NPM', value: 'NPM' },
    { label: 'TERM', value: 'TERM' }
  ];
  fileType: string = 'ALL';

  selectedUserEmployee: UserAutoCompleteItem;
  userEmployeeList: UserAutoCompleteItem[];
  userId: number = 0;
  

  dateRangeList: DateRangeModel[];
  dateRange: DateRangeModel;
  startDate: string = null;
  endDate: string = null;
  isCustomDateRange: boolean = false;

  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  totalRecords = signal<number>(0);
  
  constructor(    
    private store: Store<State>,
    private dropdownFilterService: DropdownFilterService
  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(

      this.store.select(s => s.benefitPlanEDIState.loadingTransmissions).subscribe(loading => {
        this.loadingList = loading || this.list == null;
      }),
      this.store.select(s => s.benefitPlanEDIState.exportingExcel).subscribe(loading => {
        this.exportingExcel = loading;
      }),
      this.store.select(s => s.benefitPlanEDIState.cobraTransmissions).subscribe(list => {
        this.list = list;
        if(list != null)
          this.totalRecords.set(list.totalRecords);
        this.loadingList = false;
      }),
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userEmployeeList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),
    );

    this.dateRangeList = this.dropdownFilterService.getLast120DayDateRanges();
    if (this.dateRangeList.length > 0) {
      this.dateRange = this.dateRangeList[0];
    }

  }  

  changedDateRange() {
    if (!this.dateRange) {
      return;
    }

    if (this.dateRange.isCustom) {
      this.isCustomDateRange = true;
      return; //reload after manually changing date
    }

    this.isCustomDateRange = false;
    this.startDate = this.dateRange.startDate;
    this.endDate = this.dateRange.endDate;
    this.reloadList();
  }

  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      programId: null,
      payrollClassificationId: null,
      showTerminated: true,
      showInactive: true
    }));
  }

  reloadListAfterStaffChange(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.userId = selectedUser.value.id;
    this.reloadList();
  }

  reloadListAfterClear(event) {
   
    this.userId = 0;
    this.reloadList();
  }

  reloadFilter(event) {
    this.filter = event;
    this.reloadList();
  }

  reloadList() {
    this.setFilter();    

    this.store.dispatch(getCobraTransmissions({
      filter: this.filter
    }));
  }

  setFilter() {  
    this.filter = deepClone(this.filter || { filters: {} });

    this.filter.filters.userId = { Name: 'userId', Value: { value: this.userId.toString() } };
    this.filter.filters.fileName = { Name: 'fileName', Value: { value: this.fileName } };
    this.filter.filters.fileType = { Name: 'fileType', Value: { value: this.fileType } };    
    this.filter.filters.startDate = { Name: 'startDate', Value: { value: this.startDate } };
    this.filter.filters.endDate = { Name: 'endDate', Value: { value: this.endDate } };
  }


  formatFileData(fileData: string) {
    if (!fileData) return fileData;

    // 1. Redact SSNs (123-45-6789 or 123456789)
    const ssnRegex = /\b(\d{3})-?(\d{2})-?(\d{4})\b/g;
    let text = fileData.replace(ssnRegex, '***-**-****');

    // 2. Add line breaks before [NPM] for readability
    text = text.replace(/(?<!\n)[,]*\s*\[NPM\]/g, '\n[NPM]');

    // 3. Add line breaks before [QB] for readability
    text = text.replace(/(?<!\n)[,]*\s*\[QB\]/g, '\n[QB]');

    // 4. Add a line break after [VERSION] as well
    text = text.replace(/\[VERSION\],/, '[VERSION] ');

    return text;
    
  }
  
  selectItem(item: CobraTransmissionModel) {
    if (this.selectedItem != null && item.id == this.selectedItem.id) {
      this.selectedItem = null
    }
    else {
      this.selectedItem = item;
    }
  }

  clearSelected() {
    this.selectedItem = null;
  } 

}
